import React from "react";
import { motion } from "framer-motion";

export const Section = ({ id, children, className = "", testId }) => (
  <section
    id={id}
    data-testid={testId}
    className={`relative py-24 md:py-32 px-6 md:px-12 ${className}`}
  >
    <div className="max-w-4xl mx-auto relative z-10">{children}</div>
  </section>
);

export const SectionTitle = ({ overline, title, italic }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    className="text-center mb-12"
  >
    {overline && (
      <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-gold mb-4">
        {overline}
      </p>
    )}
    <h2 className="text-4xl md:text-5xl text-charcoal font-serif">
      {title} {italic && <em className="font-script gold-text">{italic}</em>}
    </h2>
    <div className="divider mt-6">
      <svg width="20" height="20" viewBox="0 0 20 20"><path d="M10 2 L12 8 L18 10 L12 12 L10 18 L8 12 L2 10 L8 8 Z" fill="#C5A059" /></svg>
    </div>
  </motion.div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.8, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);
